













import { DropdownInputOptions, MultiValue } from '@/components/ui/DynamicTechTaskCard/types/input-field'
import AsyncValueMixin from '@/dynamic-tech-task/components/input/mixins/async-values'
import { Component } from 'vue-property-decorator'


@Component({
    name: 'DropdownInputField'
})
export default class DropdownInputField extends AsyncValueMixin<DropdownInputOptions, MultiValue> {}
